import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { LuIndianRupee } from "react-icons/lu";

const FranchiseSidebar = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    
    const currentTab = new URLSearchParams(location.search).get('tab') || 'overview';

    const handleLogout = async () => {
        await logout();
        navigate('/');
    };

    return (
        <aside className="admin-sidebar" style={{ width: '250px', background: '#ffffff', borderRight: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column' }}>
            <div className="sidebar-header" style={{ padding: '20px', borderBottom: '1px solid #e2e8f0' }}>
                <img src="/Yathartha-Logo.png" alt="Yathartha Logo" style={{ height: '40px' }} />
                <div style={{ marginTop: '10px', fontSize: '12px', color: '#64748b', fontWeight: 600 }}>FRANCHISE PORTAL</div>
            </div>
            <nav className="sidebar-nav" style={{ padding: '20px', flex: 1 }}>
                <div style={{ marginBottom: '20px' }}>
                    <div style={{ fontSize: '11px', fontWeight: 700, color: '#94a3b8', marginBottom: '10px', textTransform: 'uppercase' }}>Main</div>
                    
                    <NavLink 
                        to="/franchise/dashboard?tab=overview" 
                        className={`sidebar-link ${currentTab === 'overview' ? 'active' : ''}`}
                        style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', borderRadius: '8px', color: currentTab === 'overview' ? '#1a7a5e' : '#475569', background: currentTab === 'overview' ? '#ecfdf5' : 'transparent', textDecoration: 'none', marginBottom: '5px', fontWeight: currentTab === 'overview' ? 600 : 400 }}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '10px' }}><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                        Overview
                    </NavLink>

                    <NavLink 
                        to="/franchise/dashboard?tab=marketing" 
                        className={`sidebar-link ${currentTab === 'marketing' ? 'active' : ''}`}
                        style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', borderRadius: '8px', color: currentTab === 'marketing' ? '#1a7a5e' : '#475569', background: currentTab === 'marketing' ? '#ecfdf5' : 'transparent', textDecoration: 'none', marginBottom: '5px', fontWeight: currentTab === 'marketing' ? 600 : 400 }}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '10px' }}><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                        Marketing Kit
                    </NavLink>

                    <NavLink 
                        to="/franchise/dashboard?tab=payouts" 
                        className={`sidebar-link ${currentTab === 'payouts' ? 'active' : ''}`}
                        style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', borderRadius: '8px', color: currentTab === 'payouts' ? '#1a7a5e' : '#475569', background: currentTab === 'payouts' ? '#ecfdf5' : 'transparent', textDecoration: 'none', marginBottom: '5px', fontWeight: currentTab === 'payouts' ? 600 : 400 }}
                    >
                        <LuIndianRupee style={{ marginRight: '10px' }} size={18} />
                        Payouts
                    </NavLink>
                </div>
            </nav>
            <div className="sidebar-footer" style={{ padding: '20px', borderTop: '1px solid #e2e8f0' }}>
                <button 
                    onClick={handleLogout}
                    style={{ width: '100%', padding: '10px', background: '#fee2e2', color: '#ef4444', border: 'none', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600 }}
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                    Logout
                </button>
            </div>
        </aside>
    );
};

export default FranchiseSidebar;
